<template>
    <div class="row">
        <template v-if="recinto">
            <div class="col-12 col-lg-7" v-if="zona.with_seats">
                <AsientosComponent 
                    :zona="zona_seleccionada" 
                    :asientos="datos_compradores" 
                    :puede_cambiar="puede_cambiar"
                    :dia_abonado="dia_abonado"
                    :forzar_adyacentes="false"
                    :can_click="true"
                    :asientos_maximos="n_entradas"
                    v-on:actualizarDatos="actualizarDatos"
                ></AsientosComponent>
            </div>
            <div class="col-12 col-lg-7" v-else>
                <div class="col-12">
                    <p>Seleccione el numero de entradas</p>
                    <div class="form-group">
                        <multiselect
                            v-model="n_entradas"
                            placeholder="Seleccionar zona"
                            :show-labels="false"
                            :options="options"
                            :allow-empty="false"
                        ></multiselect>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-5">
                <div class="col-12">
                    <SelectorZonaComponent :dia_abonado="dia_abonado" :zona="zona_seleccionada" :zonas="zonas" v-on:changeZona="cambiarZona" :place="place" :sesion_id="$route.params.sesion_id"></SelectorZonaComponent>
                </div>
                <div class="col-12">
                    <TusAsientosComponent :asientos="datos_compradores" v-on:continuar="bloquearAsientos" puede_cambiar="puede_cambiar" :configuracion_valida="true"
                    :can_click="true"></TusAsientosComponent>
                </div>
            </div>
        </template>
        <template v-if="!recinto">
            <div class="col-12 col-lg-7">
                <EntradasSinRecintoComponent :entradas="entradas" v-on:actualizar="actualizar"></EntradasSinRecintoComponent>
            </div>
            <div class="col-12 col-lg-1"></div>
            <div class="col-12 col-lg-4">
                <DatosEntradasSinZonaComponent v-if="!loading" :entradas="entradas" v-on:continuar="bloquearAsientos" :siguiente="siguiente"></DatosEntradasSinZonaComponent>
            </div>
        </template>        
    </div>
</template>

<script>
    import AsientosComponent from '@/components/backend/stepper/components/AsientosComponent';
    import SelectorZonaComponent from '@/components/backend/stepper/components/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/backend/stepper/components/TusAsientosComponent';
    import EntradasSinRecintoComponent from '@/components/backend/stepper/components/EntradasSinRecintoComponent';
    import DatosEntradasSinZonaComponent from '@/components/backend/stepper/components/DatosEntradaSinZonaComponent';

    export default {
        props: ['evento', 'zona', 'datos_compradores', 'recinto', 'entradas', 'puede_cambiar', 'dia_abonado', 'place'],
        data() {
            return {
                search: '',
                search_for: 'n_abonado',
                loading: false,
                zonas: null,
                zona_seleccionada: this.zona,
                siguiente: false,
                n_entradas: 100,
                carrito_id: null,
                abonado: {}
            }
        },
        created() {
            if(this.dia_abonado) {
                this.n_entradas = 1 + this.evento.n_acompanantes;
            }

            if(this.recinto) {
                this.getZonas();
            }            
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            entradas_disponibles() {
                return this.zona.aforo - this.zona.confirmados - this.zona.no_confirmados;
            },
            options() {
                var tope = this.n_entradas;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                if(this.dia_abonado) {
                    tope = 1;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        watch: {
            n_entradas() {
                var datos = [];
                if(this.dia_abonado) {
                    this.abonado.nombre = this.datos_compradores[0].nombre;
                    this.abonado.apellidos = this.datos_compradores[0].apellidos;
                    this.abonado.id = this.datos_compradores[0].id;

                    datos.push({
                        'apellidos': this.datos_compradores[0].apellidos,
                        'asiento': {
                            'zona_id': this.zona_seleccionada.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.zona_seleccionada.name
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': this.datos_compradores[0].nombre,
                        'precio': null,
                        'precios': this.zona_seleccionada.precios,
                        'telefono': '',
                        'url_imprimir': '',
                        'id': this.datos_compradores[0].id
                    });
                } else {
                    for (var i = 0; i < this.n_entradas; i++) {
                        datos.push({
                            'apellidos': '',
                            'asiento': {
                                'zona_id': this.zona_seleccionada.id,
                                'asiento': 0,
                                'fila': 0,
                                'zona_nombre': this.zona_seleccionada.name
                            },
                            'dni': '',
                            'es_nuevo': true,
                            'nombre': '',
                            'precio': null,
                            'precios': this.zona_seleccionada.precios,
                            'telefono': '',
                            'url_imprimir': ''
                        });
                    }
                }
                

                this.datos_compradores = datos;
            }
        },
        methods: {
            actualizar (siguiente) {
                this.loading = true;
                this.$emit('actualizarEntradas');
                this.$nextTick(function() {
                    this.siguiente = siguiente;
                    this.loading = false;
                });
            },
            getZonas() {
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                });
            },
            bloquearAsientos() {
                this.loading = true;

                var seats = [];

                for(var i in this.datos_compradores) {
                    seats.push(this.datos_compradores[i].asiento);

                    seats[i].row = this.datos_compradores[i].asiento.fila;
                    seats[i].seat = this.datos_compradores[i].asiento.asiento;
                }

                var params = null;

                if(this.recinto) {
                    params = {
                        filters: {
                            sesion_id: this.$route.params.sesion_id,
                            tid: this.configuracion.hash_teatro
                        },
                        zona_id: this.zona.id,
                        asientos: seats,
                        tid: this.configuracion.hash_teatro
                    }
                } else {
                    params = {
                        filters: {
                            sesion_id: this.$route.params.sesion_id,
                            tid: this.configuracion.hash_teatro
                        },
                        entradas: this.entradas,
                        tid: this.configuracion.hash_teatro
                    }
                }

                params['taquilla'] = 1;

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                        this.getZonas();
                    } else {
                        this.carrito_id = res.data.session_id;
                        this.loading = false;
                        this.paso3 = true;
                        this.$nextTick(function() {
                            this.goTo(3);
                        });
                    }                    
                }).catch(error => {
                    console.log(error);
                    this.$toast.error("Alguno de los asientos no son válidos o se ha producido un error");
                    this.getZonas();
                    this.loading = false;
                });
            },
            goTo(paso) {
                this.$emit('goTo', paso, this.datos_compradores, this.carrito_id);
            },
            actualizarDatos(datos) {
                this.datos_compradores = [];
                this.$nextTick(function() {
                    this.datos_compradores = datos;
                    if(this.dia_abonado) {
                        for (let index = 0; index < this.datos_compradores.length; index++) {
                            if(index == 0) {
                                this.datos_compradores[index].nombre = this.abonado.nombre;
                                this.datos_compradores[index].apellidos = this.abonado.apellidos;
                                this.datos_compradores[index].id = this.abonado.id;
                                this.datos_compradores[index].precios = this.zona_seleccionada.precios_abonados;
                            } else {
                                this.datos_compradores[index].precios = this.zona_seleccionada.precios_acompanantes;
                            }                         
                        }
                        

                    }                    
                });                
            },
            cambiarZona(new_zona) {
                this.$emit('resetDatos');
                this.zona_seleccionada = null;
                this.$nextTick(function() {
                    this.zona_seleccionada = new_zona;
                });                
            }
        },
        components: {
            AsientosComponent, SelectorZonaComponent, TusAsientosComponent, EntradasSinRecintoComponent, DatosEntradasSinZonaComponent
        }
    }
</script>

<style>

</style>
